import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Typography, Button, FormControlLabel, Checkbox, Link } from '@material-ui/core'

import useScid from 'common/use-scid'
import api from 'common/api'

import StepHeader from './StepHeader'

const EnableAudienceSharing = ({ config, getConfig }) => {
  const [enableChecked, setEnabledChecked] = useState(false)
  const scid = useScid()
  const [error, setError] = useState(false)
  const activateMatching = () => {
    api
      .post(`/api/colleges/${scid}/integration/crm/configuration/activate-matching`)
      .then(() => {
        getConfig()
        setError(false)
      })
      .catch(() => setError(true))
  }
  const messagingActivated = config && config.messagingActivated
  const matchingActivated = config && config.matchingActivated
  const activatingMatching = config && messagingActivated && !matchingActivated

  return activatingMatching ? (
    <>
      <hr />
      <StepHeader
        number={2}
        text="Enable your Follower Import"
        isActive
        isComplete={false}
      />
      <Box mt={4}>
        <Typography
          variant="h6"
          component="h3"
        >
          Activate the Scoir Audience Source Format
        </Typography>
      </Box>
      <Typography
        variant="body2"
        color="textSecondary"
      >
        By enabling your follower import, we'll begin sending your interested Scoir students to Slate. Then, be sure to activate the Scoir Audience source format to start bringing the data in.
        <br /><br />
        Note: data on followers who aren't already known to you in Slate is sent in a hashed format to protect PII. Read more about how this data is stored and these records appear in Slate.
      </Typography>
      <Box
        my={4}
        pl={1}
      >
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              name="enableAudienceSharing"
              value={enableChecked}
              onClick={() => setEnabledChecked((current) => !current)}
            />
          }
          label="Enable your Follower Import"
        />
      </Box>
      <Button
        variant="contained"
        color="primary"
        disabled={!enableChecked}
        onClick={activateMatching}
      >
        Continue
      </Button>
      {error && (
        <Box mt={2}>
          <Typography
            variant="caption"
            color="error"
          >
            Something went wrong.{' '}
            <Link
              href="https://www.scoir.com/support"
              target="_blank"
              rel="noreferrer"
            >
              Please contact customer support.
            </Link>
          </Typography>
        </Box>
      )}
      <Box mt={4}>
        <Typography
          variant="caption"
          color="textSecondary"
        >
          *Stealth records are interested Scoir students, or inquiries, not yet recorded in your CRM. These students can only be reached and unlocked by selecting Scoir as your mailing channel in Slate, or directly from your Scoir account. Scoir does not share the personally identifiable information of stealth students.
        </Typography>
      </Box>
    </>
  ) : (
    <>
      <hr />
      <StepHeader
        number={2}
        text="Enable your Follower Import"
        isActive={messagingActivated && matchingActivated}
        isComplete={matchingActivated}
      />
      {matchingActivated && (
        <Box pb={1}>
          <Typography
            variant="h6"
            component="h3"
          >
            Follower Import is now enabled
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
          >
            Before you can reach your full Scoir audience from Slate, please head back over to Slate to activate the
            source format.
          </Typography>
        </Box>
      )}
    </>
  )
}

EnableAudienceSharing.propTypes = {
  config: PropTypes.object,
  getConfig: PropTypes.func.isRequired,
}

export default EnableAudienceSharing
